import { useEffect, useState } from 'react';
import { Box, Tooltip, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import API_BASE_URL from '../apiConfig';

const WEB_SHA = process.env.REACT_APP_BUILD_SHA || 'dev';
const WEB_TIME = process.env.REACT_APP_BUILD_TIME || '';

function formatTime(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleString();
  } catch {
    return iso;
  }
}

export default function BuildBadge() {
  const [api, setApi] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE_URL}/health`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!cancelled && data) setApi(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const apiSha = api?.build_sha || api?.version?.commit_hash?.slice(0, 7);
  const apiTime = api?.build_time;

  const tooltip = (
    <Box sx={{ fontFamily: 'monospace', fontSize: 12, lineHeight: 1.5 }}>
      <div>web {WEB_SHA}</div>
      {WEB_TIME && <div>built {formatTime(WEB_TIME)}</div>}
      {apiSha && <div style={{ marginTop: 4 }}>api {apiSha}</div>}
      {apiTime && <div>built {formatTime(apiTime)}</div>}
      <div style={{ marginTop: 4, fontFamily: 'inherit', opacity: 0.85 }}>
        Click to see what's new
      </div>
    </Box>
  );

  return (
    <Tooltip title={tooltip} arrow placement="top">
      <Link
        component={RouterLink}
        to="/whats-new"
        underline="hover"
        sx={{
          color: 'text.disabled',
          fontFamily: 'monospace',
          fontSize: 11,
          userSelect: 'none',
        }}
      >
        <Typography
          component="span"
          variant="caption"
          sx={{ fontFamily: 'inherit', fontSize: 'inherit' }}
        >
          {WEB_SHA}{apiSha ? ` · api ${apiSha}` : ''}
        </Typography>
      </Link>
    </Tooltip>
  );
}
